import React, { useMemo } from 'react';
import { FilterProvider } from '../../context/Filter.context';
import RoyalRoadSection from './RoyalRoad.section';
import { SortProvider } from '../../context/Sort.context';
import '../Common/styles.css';
import { ActionsProvider } from '../../context/Actions.context';
import { GenreControllerProvider } from '../../context/GenreController.context';
import getFilter from '../Common/utils/getFilter';
import { RoyalRoadEndpoints } from '../../core/constants/endpoints';
import { ISource } from '../Common/types/types';

const getTabId = (endpoint: string): string => {
  const tabId = Object.keys(RoyalRoadEndpoints).find(
    (key) => RoyalRoadEndpoints[key] === `/${endpoint}`
  ) as string;

  return tabId;
};

const RoyalRoadSectionWrapper: React.FC<ISource> = React.memo((source) => {
  const search = useMemo(() => getFilter({ getTabId }), [getTabId]);

  return (
    <FilterProvider filter={search.filter}>
      <SortProvider sort={search.sort}>
        <ActionsProvider source={source}>
          <GenreControllerProvider>
            <RoyalRoadSection />
          </GenreControllerProvider>
        </ActionsProvider>
      </SortProvider>
    </FilterProvider>
  );
});

export default RoyalRoadSectionWrapper;